import { ChatPubNub } from '@strongbody/chat-client';
import config from '../config';

/**
 * Tạo client chat-server (thay cho `new PubNub({...})`).
 *
 * Khác PubNub ở hai chỗ quan trọng:
 * - Không có `setAuthKey`. Token hết hạn thì phải `disconnect()` instance cũ và
 *   tạo instance mới bằng token mới — xem `isTokenRejected` bên dưới.
 * - `disconnect()` xoá luôn listener và làm instance không dùng lại được.
 */
export function createChatClient({ token, userId }) {
  const uuid = String(userId ?? '');
  if (!uuid) throw new Error('createChatClient: thiếu userId');
  if (!token) throw new Error('createChatClient: thiếu token');

  return new ChatPubNub({
    endpoint: config.CHAT_SERVER_ENDPOINT,
    tenant: config.CHAT_SERVER_TENANT,
    uuid,
    token,
  });
}

/**
 * Token bị từ chối / hết hạn. chat-server đóng WebSocket với mã 4401 hoặc 4403
 * và **không tự kết nối lại** — mọi lỗi khác thì SDK tự thử lại với backoff.
 * Gặp trạng thái này thì phải xin token mới rồi dựng client mới.
 */
export function isTokenRejected(statusEvent) {
  return statusEvent?.category === 'PNAccessDeniedCategory';
}
